import * as React from 'react';

import PageHeader from 'buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/pageHeader';
import { userUrl } from 'buyside/util/urlHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import SZLogo from 'buyside/svgs/sz_logo_dark_full.svg';
import Card from 'buyside/components/presentation/Card/card';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import PenAndPaperIcon from 'buyside/svgs/pen_and_paper.svg';

import styles from 'buyside/components/presentation/AccreditedInvestorProfilePage/Pages/pageStyles.scss';

const AccreditedInvestorSuccessPage: React.FunctionComponent<{ userId: string }> = ({
  userId
}): React.ReactElement => (
  <div className={styles.successContainer}>
    <PageHeader subHeader="Success" />

    <div className={styles.content}>
      <FontAwesomeIcon icon={faCheck} className={styles.faCheck} />

      <Card customStyles={styles.card}>
        <div className={styles.banner}>
          <SZLogo className={styles.szLogo} />
        </div>

        <div className={styles.contentBody}>
          <div className={styles.successMessage}>
            <p className={styles.displayBlock}>You're verified as an</p>
            <p className={styles.accreditedInvestor}>Accredited Investor!</p>
          </div>

          <Button
            size={BUTTON_SIZES.LARGE}
            type={BUTTON_TYPES.PRIMARY}
            className={styles.profileLink}
            url={userUrl(userId)}
            icon={PenAndPaperIcon}
            text="Complete Your Profile"
          />
        </div>
      </Card>
    </div>
  </div>
);

export default AccreditedInvestorSuccessPage;
